import {useService} from '@cindedi/react-application';
import type {MetaFunction, LoaderFunction} from '@remix-run/node';
import {json} from '@remix-run/node';
import {Link, useLoaderData} from '@remix-run/react';
import {PublicLayout} from '~/domains/organization/components/PublicLayout';
import {seoMeta} from '~/domains/organization/utilities/seoMeta';

export interface DisciplinasLoaderData {
  disciplines: Academic.PublicDisciplineDto[];
}

export const meta: MetaFunction = function DisciplinasMeta({matches}) {
  return seoMeta('disciplinas', {title: 'Disciplinas - Cindedi', description: 'Conheça as disciplinas e aulas do CINDEDI! Descubra os cursos ministrados por nossos professores.'}, matches);
};

export const loader: LoaderFunction = async function DisciplinasLoader({context: {use}}) {
  const Discipline = use('Discipline');

  const disciplines = await Discipline.all();

  return json({disciplines: disciplines.sortBy('name')});
};

export default function DisciplinasView() {
  const {disciplines} = useLoaderData<DisciplinasLoaderData>();
  useService('organization/titlebar').setTitle('Disciplinas');

  return (
    <PublicLayout>
      <ul role="list" className="flex flex-col gap-2">
        {disciplines.map((discipline) => (
          <li key={discipline.id} className="hover:bg-shade-3 bg-shade-2 rounded">
            <Link target="_blank" to={discipline.url}>
              <div className="px-2 py-3 flex flex-col">
                <span className="font-semibold text-primary-12">{discipline.name}</span>
                <span>Prof. {discipline.professor}</span>
                <div className="flex gap-2 text-shade-11 text-sm items-center mt-1">
                  <span>{discipline.type}</span>•<span>{discipline.workload}</span>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </PublicLayout>
  );
}
